import { BaseFlowRuleStep } from "./BaseFlowRuleStep";
import { IntersectionRuleConfiguration } from "../../../Rule/Intersection/IntersectionRuleConfiguration";

export class RunIntersectionRule extends BaseFlowRuleStep {
    readonly __type: string = "run_intersection_rule";

    executable: IntersectionRuleConfiguration = new IntersectionRuleConfiguration();

    constructor() {
        super();
        this.name = "Run Intersection Rule";
    }
}
